import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './home';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import NewHome from "./new-home";


const routing = (

    <BrowserRouter>

        <Routes>
            <Route path='/' element={<NewHome/>}/>

        </Routes>

    </BrowserRouter>
)


ReactDOM.render([routing], document.getElementById('root'))


